import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'
import { DEFAULT_THEME_COLORS } from '@/helpers/defaultTheme'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: DEFAULT_THEME_COLORS.primary,
        secondary: DEFAULT_THEME_COLORS.secondary,
        accent: '#8c9eff',
        error: '#b71c1c',
        background: colors.grey.lighten4
      }
    }
  }
})
